import { LinkProps } from '@mui/material/Link'
import { Components, Theme } from '@mui/material/styles'
import * as React from 'react'
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
  useLocation,
} from 'react-router-dom'

export const LinkBehavior = React.forwardRef<
  HTMLAnchorElement,
  Omit<RouterLinkProps, 'to'> & { href: RouterLinkProps['to'] }
>((props, ref) => {
  const { href, ...other } = props
  const location = useLocation()
  const isActive = location.pathname === href
  return (
    <RouterLink
      ref={ref}
      to={href}
      {...other}
      className={isActive ? other.className + ' Mui-selected' : other.className}
    />
  )
})

export const navigationCustomizations: Components<Theme> = {
  MuiLink: {
    defaultProps: {
      underline: 'none',
      component: LinkBehavior,
    } as LinkProps,
    styleOverrides: {
      root: ({ theme }) => ({
        '&.Mui-selected': {
          color: theme.palette.primary.main,
          fontWeight: 600,
        },
        textDecoration: 'none',
        width: 'fit-content',
      }),
    },
  },
  MuiDrawer: {
    styleOverrides: {
      paper: ({ theme }) => ({
        backgroundColor: theme.palette.background.default,
      }),
    },
  },
}
